export const WellbeingFeedCardTypes = {
  Thumbnail: 'Thumbnail',
  Activity: 'Activity',
  Notification: 'Notification',
  Integration: 'Integration',
} as const;
